<template>
    <div class="login_entry">
        <main>
            <div class="product_con">
                <div id="product_cont_list" @mousewheel="mouseWheelTo" class="product_content">
                    <div
                        v-for="product in productData"
                        class="product_item"
                        :key="product.id"
                        @click="goProduct(product)"
                    >
                        <div class="product_item_con">
                            <div class="product_bg" :style="{'background-image': `url(${product.eliteConfig?.qrCodeBackground})`}"></div>
                            <div class="pro_circle"></div>
                            <img :src="product.logo" alt />
                            <span class="product_name SysFontM">{{ product.name }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card_more" v-if="productData.length">
                <div @click="goPre()">
                    <cl-svg-icon class="icon_svg" icon-class="left-arrow" width="14"></cl-svg-icon>
                </div>
                <div @click="goNext()">
                    <cl-svg-icon class="icon_svg" icon-class="right-arrow" width="14"></cl-svg-icon>
                </div>
            </div>
        </main>
        <!--欢迎页面-->
        <welcome-login ref="welcomeLogin"></welcome-login>
    </div>
</template>

<script>
import welcomeLogin from './components/welcome-login.vue'
import loginMixin from './mixin/login';
const ipcRenderer = window.require ? window.require('electron').ipcRenderer : '';

export default {
    mixins: [loginMixin],
    components: {
        welcomeLogin
    },
    data () {
        return {
            productData: [], // 产品列表
            loginAnimation: false,
            tenantTitles: [], // 中英文翻译
            cardWidth: 220 + 32, // 卡片的宽度
            left: 0,
        }
    },
    mounted () {
        this.getTenantList();
    },
    methods: {
        mouseWheelTo(e){
            let direction = e.deltaY > 0 ? 'down':'up';
            if(direction == 'up'){
                this.goPre();
            } else {
                this.goNext();
            }
        },
        goPre(){
            if (this.left >= 0) return
            this.left += this.cardWidth
            let dom = document.getElementById('product_cont_list')
            dom.style.left = this.left + 'px'
        },
        goNext(){
            let dom = document.getElementById('product_cont_list')
            let offsetLeft = this.cardWidth * (this.productData.length - 4)
            if (this.left <= -offsetLeft) return
            this.left -= this.cardWidth
            dom.style.left = this.left + 'px'
        },
        // 获取当前用户可以访问的机构列表
        getTenantList () {
            this.$server.getTenantList({ appType: this.$baseUrl.PLATFORM }).then(res => {
                if (res.data && res.data.length) {
                    this.productData = res.data;
                }
            })
        },
        goProduct (product) {
            // 设置 上传，下载的文件名称 VUE_APP_DOWN_KEY + tenantId
            let bucketData = this.$baseUrl.APP_NAME_LOWER;
            let name = bucketData + product.id;
            ipcRenderer && ipcRenderer.send('ossFileName', name);
            // 设置 tenant
            this.$store.commit('setTenant', ''); // 清空训练营tenantId
            this.$store.commit('setGroup', product.id); // 设置集团id
            this.$store.commit('setTenantData', product);
            this.$server.getTenant({ id: product.id }).then(res => {
                if (res.data) {
                    this.$store.commit('setTenantData', { ...product, ...res.data });
                    // 获取当前用户的信息
                    let data = this.$sg.ls.get('loginType') == 'email' ? {
                        identifier: this.$sg.ls.get('userPassword').email,
                        identifierType: 'username',
                    } : {
                        identifier: this.$sg.ls.get('userPhone').phone,
                        identifierType: 'phone',
                    };
                    this.$server.getUserBaseInfo(data).then(res => {
                        if (res.code == 200) {
                            this.$store.commit('setUserData', res.data || {});
                            this.$router.push({
                                path: '/home',
                            })
                        }
                    })
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.login_entry {
    height: 100%;
    background-image: url(./images/login_entry_bg.png);
    background-size: 100% 500px;
    background-repeat: no-repeat;
    background-color: #f3f3f3;
    position: relative;
    main {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        overflow: hidden;
        overflow-y: auto;
        padding-top: 420px;
        .product_con {
            padding: 0 0 30px 70px;
            overflow: hidden;
            &:nth-child(2n) {
                background-image: url(./images/login_product_bg2.png);
            }
            &:nth-child(3n) {
                background-image: url(./images/login_product_bg3.png);
            }
            &:nth-child(4n) {
                background-image: url(./images/login_product_bg4.png);
            }
            .product_title {
                font-size: 18px;
                line-height: 25px;
                padding-bottom: 12px;
                color: #3a3a3a;
            }
            .product_content {
                width: 10000px;
                position: relative;
                left: 0;
                transition: all 0.3s;
                display: flex;
                flex-wrap: wrap;
            }
            .product_item {
                border-radius: 12px;
                height: 258px;
                width: 220px;
                margin: 0 32px 0 0;
                position: relative;
                background: #ffffff;
                box-shadow: #00000010 10px 10px 6px;
                .product_bg{
                    position: absolute;
                    z-index: -2;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    background-position: top center;
                }
                .pro_circle{
                    position: absolute;
                    z-index: -1;
                    top: 38px;
                    background: #ffffff;
                    border-radius: 50%;
                    width: 140px;
                    height: 140px;
                }
                .product_item_con {
                    position: relative;
                    height: 100%;
                    width: 100%;
                    left: 0;
                    top: 0;
                    z-index: 2;
                    overflow: hidden;
                    border-radius: 12px;
                    display: flex;
                    flex-direction: column;
                    box-sizing: border-box;
                    align-items: center;
                    cursor: pointer;
                }
                .product_type{
                    position: absolute;
                    left: 10px;
                    top: 10px;
                    width: 46px;
                    height: 23px;
                    border-radius: 0;
                    margin: 0;
                }
                .layer {
                    position: absolute;
                    background: #f1f1f1;
                    filter: blur(5px);
                    border-radius: 8px;
                    width: 180px;
                    height: 35px;
                    top: 178px;
                    left: 18px;
                }
                img {
                    height: 120px;
                    width: 120px;
                    border-radius: 50%;
                    margin: 49px 0 34px;
                    border: none;
                }
                .product_name {
                    font-size: 16px;
                    line-height: 22px;
                    color: #1a1a1a;
                }
            }
        }
    }
    .card_more{
        width: 100%;
        height: 40px;
        text-align: center;
        > div {
            width: 32px;
            height: 32px;
            line-height: 26px;
            background: #fff;
            border-radius: 50%;
            color: #b7b7bf;
            display: inline-block;
            cursor: pointer;
            &:first-child{
                margin-right: 40px;
            }
            &:hover {
                @extend .is-active;
            }
        }
        .is-active {
            background: #3663e1;
            color: #fff;
        }
        .icon_svg {
            font-size: 28px;
        }
    }
}
</style>
